/**
 * @param {Object[]} playbooks Hasura API response for integration playbooks
 * @returns {string[]} Array of unique cluster IDs
 */
function getClusterIdsFromPlaybooks(playbooks) {
  if (!Array.isArray(playbooks)) {
    return [];
  }

  // flatten all staged revisions
  const stagedRevisions = playbooks.flatMap(playbook =>
    Array.isArray(playbook.staged_revisions) ? playbook.staged_revisions : []
  );

  const clusterIds = stagedRevisions.reduce((acc, stagedRevision) => {
    const clusterId = stagedRevision.pipeline_integration?.pipeline?.cluster?.id;

    if (clusterId) {
      acc.add(clusterId);
    }

    return acc;
  }, new Set());

  return Array.from(clusterIds);
}

export default getClusterIdsFromPlaybooks;
